import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './stiller/tokens.css';
import './stiller/temel.css';
import './stiller/bilesenler.css';
import './stiller/belge.css';
import './stiller/log.css';
import { Uygulama } from './Uygulama.js';
import { OturumSaglayici } from './lib/oturum.js';
import { BildirimSaglayici } from './lib/bildirim.js';
import { temayiOku, temayiUygula } from './lib/tema.js';

/* Tema, ilk boyamadan önce uygulanır: açılışta ekran titremez. */
temayiUygula(temayiOku());

createRoot(document.getElementById('kok')!).render(
  <StrictMode>
    <BrowserRouter>
      <BildirimSaglayici>
        <OturumSaglayici>
          <Uygulama />
        </OturumSaglayici>
      </BildirimSaglayici>
    </BrowserRouter>
  </StrictMode>,
);
